export const ADMIN_ROLES = {
  superAdmin: {
    name: 'Super Admin'
  },
  admin: {
    name: 'Region Admin'
  }
}
